import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RevenueChart = () => {
  const data = [
    { month: 'Aug', income: 45000, expenses: 12000 },
    { month: 'Sep', income: 48000, expenses: 15000 },
    { month: 'Oct', income: 52000, expenses: 14000 },
    { month: 'Nov', income: 49000, expenses: 16000 },
    { month: 'Dec', income: 55000, expenses: 13000 },
    { month: 'Jan', income: 58000, expenses: 17000 },
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Revenue & Expenses</h3>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: 'var(--color-accent)' }}></div>
            <span className="text-sm text-muted-foreground font-caption">Income</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: 'var(--color-warning)' }}></div>
            <span className="text-sm text-muted-foreground font-caption">Expenses</span>
          </div>
        </div>
      </div>
      <div className="w-full h-80" aria-label="Revenue and Expenses Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'Inter, sans-serif' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'Inter, sans-serif' }}
              tickFormatter={(value) => `£${(value / 1000)?.toFixed(0)}k`}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-surface)', 
                border: '1px solid var(--color-border)',
                borderRadius: '10px',
                fontFamily: 'Inter, sans-serif'
              }}
              formatter={(value) => `£${value?.toLocaleString()}`}
            />
            <Legend 
              wrapperStyle={{ 
                fontFamily: 'Inter, sans-serif',
                fontSize: '12px'
              }}
            />
            <Bar dataKey="income" fill="var(--color-accent)" radius={[6, 6, 0, 0]} />
            <Bar dataKey="expenses" fill="var(--color-warning)" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;